import { render, staticRenderFns } from "./TranstantUserManagement.vue?vue&type=template&id=d26d219c"
import script from "./TranstantUserManagement.vue?vue&type=script&lang=js"
export * from "./TranstantUserManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports